import React from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { CONTACT_EMAIL, VISIBLE_SOCIAL_LINKS } from '../../constants/contactLinks';

const BUTTON_CLASS =
  'inline-flex flex-1 min-w-0 items-center justify-center gap-2 rounded-full border border-edge bg-surface-muted px-3 py-2.5 text-sm font-medium text-ink transition-colors hover:border-edge-strong hover:bg-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-canvas';

export default function ContactBox({ className = '' }) {
  const { t } = useTranslation();

  return (
    <aside
      className={`rounded-lg border border-edge bg-surface p-5 shadow-sm ${className}`.trim()}
    >
      <p className="text-sm leading-6 text-ink-muted text-justify">{t('contactBox.intro')}</p>

      <div className="mt-4 flex flex-wrap items-stretch gap-3">
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className={BUTTON_CLASS}
          aria-label={t('contactBox.emailAria', { email: t('common.contactEmail') })}
        >
          <FaEnvelope className="h-4 w-4 shrink-0 text-ink-subtle" aria-hidden />
          <span className="truncate">{t('contactBox.emailButton')}</span>
        </a>

        {VISIBLE_SOCIAL_LINKS.map((item) => (
          <a
            key={item.key}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className={`${BUTTON_CLASS} ${item.hoverClass}`}
            aria-label={t(item.labelKey)}
          >
            <svg className="h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
              <path d={item.path} />
            </svg>
            <span className="truncate">{t(item.labelKey)}</span>
          </a>
        ))}
      </div>
    </aside>
  );
}
